export default __webpack_public_path__ + "static/media/TBM.5f1f0ce8.png";